export class EditVacationTypeDialogModel {

    public id: string;
    public name: string;
    public color: string;
    public error: string;

}